<div class="checkin-accordion">
  <ng-content></ng-content>
</div>